import { render, staticRenderFns } from "./modal_tendency.vue?vue&type=template&id=e2d4c43e&scoped=true&"
import script from "./modal_tendency.vue?vue&type=script&lang=js&"
export * from "./modal_tendency.vue?vue&type=script&lang=js&"
import style0 from "./modal_tendency.vue?vue&type=style&index=0&id=e2d4c43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d4c43e",
  null
  
)

export default component.exports